import { type CSSResult, unsafeCSS } from 'lit';

export type MarginValue = string | number | CSSResult;

/**
 * Apply right margin.
 * @param {MarginValue} margin
 */
export function mr(margin: MarginValue) {
	return unsafeCSS(`
		margin-inline-end: ${margin}
	`);
}

/**
 * Apply left margin.
 * @param {MarginValue} margin
 */
export function ml(margin: MarginValue) {
	return unsafeCSS(`
		margin-inline-start: ${margin}
	`);
}

/**
 * Apply right/left margins.
 * @param {MarginValue} margin
 */
export function mx(margin: MarginValue) {
	return unsafeCSS(`
		${ml(margin)};
		${mr(margin)}
	`);
}

/**
 * Apply top margin.
 * @param {MarginValue} margin
 */
export function mt(margin: MarginValue) {
	return unsafeCSS(`
		margin-block-start: ${margin}
	`);
}

/**
 * Apply bottom margin.
 * @param {MarginValue} margin
 */
export function mb(margin: MarginValue) {
	return unsafeCSS(`
		margin-block-end: ${margin}
	`);
}

/**
 * Apply top/bottom margins.
 * @param {MarginValue} margin
 */
export function my(margin: MarginValue) {
	return unsafeCSS(`
		${mt(margin)};
		${mb(margin)}
	`);
}

/**
 * Apply right/left/top/bottom margins.
 * @param {MarginValue} margin
 */
function m(margin: MarginValue) {
	return unsafeCSS(`
		${mx(margin)};
		${my(margin)}
	`);
}

export default m;
